<template>
    <button
        type="button"
        :class="{
            'lead-list-tab-label': true,
            'lead-list-tab-label--active': props.active,
        }"
    >
        <text-decorator :size="FontSize.md">
            <slot />
        </text-decorator>

        <span class="lead-list-tab-label__float">
            <chip-informative medium :color="props.chipColor">
                <slot name="count">
                    0
                </slot>
            </chip-informative>
        </span>
    </button>
</template>

<script setup lang="ts">
    import { ChipInformative, Color, type ColorType, FontSize } from '@keyvue/one-ui';

    interface Props {
        active?: boolean
        chipColor?: Color | ColorType
    }

    const props = withDefaults(defineProps<Props>(), {
        active: false,
        chipColor: 'gray-800',
    });
</script>

<style scoped lang="scss">
.lead-list-tab-label {
    display: flex;
    position: relative;
    box-sizing: content-box;
    height: size(xl);
    padding: 0 size(md);

    align-items: center;

    background-color: color(brand-white);
    border: 1px solid color(gray-300);
    border-bottom: 0;
    border-top-left-radius: size(xs);
    border-top-right-radius: size(xs);

    cursor: pointer;

    transition: background-color .2s;

    &__float {
        position: absolute;
        top:0;
        left:0;
        right:0;
        transform: translateY(-50%);
    }

    &--active {
        padding: size(xs) size(md);
        background-color: var(--theme-colors-default--primary);
        color: color(brand-white);
    }
}
</style>
